<template>
  <div>
    <el-form label-position="top" @submit.native.prevent>
      <el-row :gutter="10" class="u-mt-10 u-mb-10">
        <el-col :xs="24" :sm="12" :md="12" v-if="exibeSelectInstituicao">
          <el-form-item label="Instituição" key="instituicao">
            <el-select v-model="instituicaoSelected" filterable placeholder="Selecione" clearable @change="changeInstituicao">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6">
          <el-form-item label="Ano" key="ano">
            <el-select v-model="anoSelected" filterable @change="loadDashboard">
              <el-option v-for="y in anosDisponiveis" :key="y" :label="String(y)" :value="y"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="!instituicaoAtivaId" class="u-text-center u-mt-25 u-text-muted">
      Selecione uma instituição para visualizar o dashboard financeiro.
    </div>

    <template v-if="instituicaoAtivaId">
      <el-row :gutter="10" class="u-mt-10">
        <el-col :xs="24" :sm="6" :md="6">
          <div class="card kpi">
            <div class="kpi__label">Recursos recebidos</div>
            <div class="kpi__value">{{ formatMoney(dados.recursos_recebidos) }}</div>
            <div class="kpi__hint">Ano {{ anoSelected }} / instituição</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6">
          <div class="card kpi">
            <div class="kpi__label">Em cotação</div>
            <div class="kpi__value">{{ formatMoney(dados.recursos_em_cotacao) }}</div>
            <div class="kpi__hint">Cotações em aberto</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6">
          <div class="card kpi">
            <div class="kpi__label">Gastos</div>
            <div class="kpi__value">{{ formatMoney(dados.recursos_gastos) }}</div>
            <div class="kpi__hint">Total registrado</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6">
          <div class="card kpi kpi--primary">
            <div class="kpi__label">Saldo disponível</div>
            <div class="kpi__value">{{ formatMoney(dados.saldo_disponivel) }}</div>
            <div class="kpi__hint">Recebidos - gastos</div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="u-mt-15">
        <el-col :xs="24" :sm="12" :md="12">
          <c-panel title="Gastos por categoria (Top 10)" titleIcon="fas fa-chart-bar">
            <div class="chart-box chart-box--md">
              <bar-chart class="chart-canvas" :chart-data="chartCategoria"></bar-chart>
            </div>
          </c-panel>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12">
          <c-panel title="Gastos por programa (Top 10)" titleIcon="fas fa-chart-bar">
            <div class="chart-box chart-box--md">
              <bar-chart class="chart-canvas" :chart-data="chartPrograma"></bar-chart>
            </div>
          </c-panel>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="u-mt-10">
        <el-col :xs="24" :sm="24" :md="24">
          <c-panel title="Gastos por tipo" titleIcon="fas fa-chart-pie">
            <div class="chart-box chart-box--md">
              <doughnut-chart class="chart-canvas" :chart-data="chartTipo"></doughnut-chart>
            </div>
          </c-panel>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24">
          <c-panel title="Execução do recurso (%)" titleIcon="fas fa-percentage">
            <div class="chart-box chart-box--md">
              <bar-chart class="chart-canvas" :chart-data="chartExecucao"></bar-chart>
            </div>
          </c-panel>
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue'),
    BarChart: () => import('@/chart/BarChart'),
    DoughnutChart: () => import('@/chart/DoughnutChart')
  },
  data: () => ({
    anoSelected: (new Date()).getFullYear(),
    anosDisponiveis: [],
    instituicaoSelected: '',
    dados: {
      recursos_recebidos: 0,
      recursos_em_cotacao: 0,
      recursos_gastos: 0,
      saldo_disponivel: 0,
    }
    ,
    chartTipo: { labels: [], datasets: [{ label: 'Gastos', data: [], backgroundColor: ['#50964d', '#f5a623', '#346daa', '#d0021b'] }] },
    chartCategoria: { labels: [], datasets: [{ label: 'Gastos (R$)', data: [], backgroundColor: '#346daa' }] },
    chartPrograma: { labels: [], datasets: [{ label: 'Gastos (R$)', data: [], backgroundColor: '#50964d' }] },
    chartExecucao: { labels: [], datasets: [{ label: 'Execução (%)', data: [], backgroundColor: '#f5a623' }] }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    },
    instituicaoAtivaId () {
      const inst = this.$store.state.config.instituicao
      return inst && inst.id ? inst.id : ''
    }
  },
  mounted () {
    this.initAnos()
    if (this.$store.state.config.instituicao) {
      this.instituicaoSelected = this.$store.state.config.instituicao.id
    }
    if (this.instituicaoAtivaId) {
      this.loadDashboard()
    }
  },
  methods: {
    initAnos () {
      const current = (new Date()).getFullYear()
      const anos = []
      for (let y = current; y >= current - 7; y--) anos.push(y)
      this.anosDisponiveis = anos
      if (!this.anoSelected) this.anoSelected = current
    },
    async changeInstituicao () {
      if (this.exibeSelectInstituicao) {
        await this.$store.dispatch('setInstituicao', this.instituicaoSelected)
      }
      this.loadDashboard()
    },
    loadDashboard () {
      const instituicaoId = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null
      if (!instituicaoId) return

      window.eventBus.$emit('loading', true)
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/financeiro/dashboard/` + instituicaoId + `?ano=${this.anoSelected}`, this.$store.getters.getHeaderAuth).then((response) => {
        this.dados = Object.assign({}, this.dados, response.data || {})
        this.buildCharts(this.dados.charts || {})
        window.eventBus.$emit('loading', false)
      }).catch((error) => {
        window.eventBus.$emit('loading', false)
        this.$store.commit('throwException', error)
      })
    },
    buildCharts (charts) {
      // tipo
      const tipo = charts.gastos_por_tipo || []
      this.chartTipo = {
        labels: tipo.map(i => i.label),
        datasets: [{
          label: 'Gastos (R$)',
          data: tipo.map(i => Number(i.value || 0)),
          backgroundColor: ['#50964d', '#f5a623', '#346daa', '#d0021b', '#9013fe', '#4a4a4a']
        }]
      }

      // categoria
      const cat = charts.gastos_por_categoria || []
      this.chartCategoria = {
        labels: cat.map(i => i.label),
        datasets: [{
          label: 'Gastos (R$)',
          data: cat.map(i => Number(i.value || 0)),
          backgroundColor: '#346daa'
        }]
      }

      // programa
      const prog = charts.gastos_por_programa || []
      this.chartPrograma = {
        labels: prog.map(i => i.label),
        datasets: [{
          label: 'Gastos (R$)',
          data: prog.map(i => Number(i.value || 0)),
          backgroundColor: '#50964d'
        }]
      }

      // execucao
      const exec = charts.execucao_percentual_por_programa || []
      this.chartExecucao = {
        labels: exec.map(i => i.label),
        datasets: [{
          label: 'Execução (%)',
          data: exec.map(i => Number(i.value || 0)),
          backgroundColor: '#f5a623'
        }]
      }
    },
    formatMoney (value) {
      const v = Number(value || 0)
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 6px;
  padding: 14px 14px;
  border: 1px solid rgba(0,0,0,0.06);
}
.kpi__label {
  font-size: 12px;
  color: rgba(0,0,0,0.60);
  text-transform: uppercase;
}
.kpi__value {
  font-size: 22px;
  font-weight: 700;
  margin-top: 6px;
  color: rgba(0,0,0,0.87);
}
.kpi__hint {
  font-size: 12px;
  margin-top: 4px;
  color: rgba(0,0,0,0.50);
}
.kpi--primary {
  border-left: 4px solid #346daa;
}
.chart-box { position: relative; width: 100%; overflow: hidden; height: 320px; }
.chart-canvas { display: block; width: 100% !important; height: 100% !important; }
.chart-box ::v-deep canvas { width: 100% !important; height: 100% !important; }
</style>

